import React from 'react';
import { TableHeaderCellProps } from './types';
import { StyledTableHeaderCell } from './TableHeaderCell.styles';

export default function TableHeaderCell(props: TableHeaderCellProps) {
  const { children, action, ...otherProps } = props;

  return (
    <StyledTableHeaderCell {...otherProps}>
      <div className="th-content">
        {children}
        {action && action}
      </div>
    </StyledTableHeaderCell>
  );
}
